import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { ServerService } from 'src/app/services/server.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ClipboardService } from 'ngx-clipboard';
import { ClipBoardService } from 'src/app/services/clipboard.service';
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  userData:any;
  token = localStorage.getItem('token');
  passwordForm: FormGroup;
  passwordFormVisibility = true;
  form = "pass";
  suggestedPassword:any;
  hide = true;
  hideConfirm = true;
  suggesPass:any = '';
  showEyeSuggestPassword = false;
  showSuggestPassword = true;
  radioValue = 'password';
  copyButtonClicked = false;
  userInfo = JSON.parse(localStorage.getItem('userInfo'))
  constructor(
    private dialogRef: MatDialogRef<ResetPasswordComponent>,
    @Inject(MAT_DIALOG_DATA) private data,
    private serverService:ServerService,
    private fb: FormBuilder,
    private clipboardService: ClipboardService,
    private msg:ClipBoardService
  ) { 
    this.userData = data;
    // console.log(data)

    this.passwordForm = this.fb.group({
      "password": ["",[Validators.required,Validators.minLength(8)]],
      "password_confirmation": ["", Validators.required],
      "suggesPass":[{value: '', disabled: true} ,Validators.required],
  },{ validator: this.checkIfMatchingPasswords('password', 'password_confirmation') });
  }

  ngOnInit() {
  }
  close() {
    this.dialogRef.close();
}
passwordButton(event:any){
  // debugger;
  this.copyButtonClicked = false;
  if(event.target.value == 'pass')
  {

    this.radioValue = 'password'
    this.showSuggestPassword = true
    this.passwordForm.get('password').setValidators([Validators.required,Validators.minLength(8)]);
    this.passwordForm.get('password_confirmation').setValidators([Validators.required,Validators.minLength(8)]);
    this.passwordForm.get('suggesPass').clearValidators();
    this.passwordForm.reset()
    this.passwordFormVisibility = true;
    this.showEyeSuggestPassword = false;
  }
  if(event.target.value == 'confirmpass'){
    // this.
    this.suggesPass = '';
    this.radioValue = 'suggestPassword'
    this.passwordForm.controls.suggesPass.reset()
    this.passwordForm.get('password').clearValidators();
    this.passwordForm.get('password_confirmation').clearValidators();
    this.passwordForm.get('suggesPass').setValidators([Validators.required]);
    this.passwordForm.reset()
    this.passwordFormVisibility = false;

  }
  this.passwordForm.get('password').updateValueAndValidity();
  this.passwordForm.get('password_confirmation').updateValueAndValidity();
  this.passwordForm.get('suggesPass').updateValueAndValidity();

}
reset(){
  let body = {}
  if(this.radioValue == 'password'){
    body =  {
      'user_id':this.data.id,
      'password':this.passwordForm.value.password,
      'password_confirmation':this.passwordForm.value.password_confirmation,
    }
  }
    else
    {
      body = {
        'user_id':this.data.id,
        'password':this.suggesPass,
        'password_confirmation':this.suggesPass,
      }
    }
  

  this.serverService.resetUserPassword(body,this.token).subscribe((data)=>{
    data["password"] = body['password']
    this.dialogRef.close(data);
    // this.msg.showMessgeInText('Password has been successfully set for user', "success-snackbar");
  })
}
checkIfMatchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
  // debugger;
  return (group: FormGroup) => {
    const passwordInput = group.controls[passwordKey],
      passwordConfirmationInput = group.controls[passwordConfirmationKey];
    if (passwordInput.value !== passwordConfirmationInput.value) {
      return passwordConfirmationInput.setErrors({ notEquivalent: true })
    }
    else {
      return passwordConfirmationInput.setErrors(null);
    }
  }
}
showPassword(){
  this.hide = !this.hide;
  
}
showConfirmPassword(){
  this.hideConfirm = !this.hideConfirm;
}
generateRandomPassword(): string {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+[]{}|;:,.<>?';
  const passwordLength = 8;

  return Array.from({ length: passwordLength }, () => {
    const randomIndex = Math.floor(Math.random() * characters.length);
    return characters.charAt(randomIndex);
  }).join('');
}
suggestPassword(){
  this.passwordForm.controls.suggesPass.clearValidators()
  this.showEyeSuggestPassword = true
  this.suggestedPassword = this.generateRandomPassword()

  this.passwordForm.value.suggesPass = this.suggestedPassword
  this.suggesPass = this.passwordForm.value.suggesPass;
  this.showSuggestPassword = false;
}
copyText(){
  this.clipboardService.copyFromContent(this.suggesPass);
  this.copyButtonClicked = true;
}

}
